<template>
  <div>
    <div class="footer_amidvw">
      <div class="footer_ami1">
        <div class="footer_amil">
          <div class="footer_amil_logo">
            <img src="@/assets/img/fodown_one_1n.webp" alt="">
          </div>
          <!--<div class="footer_amil_googleplay">
            <div class="footer_amil_googleplay_1">
              <a
                      href="https://play.google.com/store/apps/details?id=com.amigocredi.loan"
                      target="_blank"
                      class="playBtn"
              >
              <img src="@/assets/img/footer_googleplay.webp" alt="">
              </a>
            </div>
          </div>-->
          <div class="footer_amil_lmext"><em>Su socio financiero de confianza</em></div>
        </div>
        <div class="footer_amir">
          <div class="footer_amir_v">
            <div class="footer_amir_vt">Garantías de Seguridad</div>
            <div class="footer_amir_vp" @click.stop="goP">Aviso de Privacidad</div>
            <div class="footer_amir_vp" @click="goT">Términos y Condiciones</div>
          </div>
          <div class="footer_amir_v">
            <div class="footer_amir_vt">Contáctanos</div>
            <div class="footer_amir_vp">Teléfono: +52 55 287 85963</div>
            <div class="footer_amir_vp">WhatsApp: +52 55 287 85963</div>
            <div class="footer_amir_vp">Correo electrónico: avanzarpidoservice@gmail.com</div>
            <div class="footer_amir_vp_n">Tiempo laboral：<br/>Lunes a Viernes de 08:00 a 17:00 y Sábado de 08:00 a 16:00</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/foot.scss";

export default {
  name: "footPage",
  data() {
    return {};
  },
  methods: {
    goFacebook() {
      window.location.href = 'https://www.facebook.com/profile.php?id=61576050817729';
    },
    goInstagram() {
      window.location.href = 'https://www.instagram.com/arrecredi_atc/'
    },
    openGooglePlayLink() {
      //console.log('googleplay')
      window.location.href = 'https://app.adjust.com/1o8iv5h7';
    },
    goAbount(){
      this.$router.push({
        path: '/empresa'
      })
    },
    goP(){
      this.$router.push({
        path: '/privacy'
      })
    },
    goT(){
      this.$router.push({
        path: '/protocolo'
      })
    },
    goLink(type) {
      this.$router.push({
        path: '/loan',
        query: {
          activeName: type
        }
      })
    }
  }
};
</script>

<style lang="scss">
  .footer_amidvw{
    width: 100%;
    height: 820px;
    background: url("../assets/img/moneymex_footer_img.webp") no-repeat center center;
    background-size: 1920px 100%;
    background-color: #0F0000;
    .footer_ami1{
      width: 1440px;
      height: 323px;
      margin: 0 auto;
      padding: 320px 0 0 0;
      display: flex;
      justify-content: space-between;
      .footer_amil{
        width: 466px;
        height: 323px;
        box-sizing: border-box;
        padding: 0 0 0 36px;
        .footer_amil_logo{
          width: 245px;
          height: 56px;
          padding: 29px 0 0 0;
          img {
            display: block;
            width: 100%;
            height: 56px;
          }
        }
        .footer_amil_lmext{
          width: 245px;
          height: auto;
          padding: 24px 0 0 0;
          font-family: Roboto, Roboto;
          font-weight: bold;
          font-size: 24px;
          color: #DFDCE6;
          line-height: 34px;
          text-align: left;
          font-style: italic;
        }
        .footer_amil_googleplay{
          width: 100%;
          height: 41px;
          position: relative;
          .footer_amil_googleplay_1{
            width: 128px;
            height: 50px;
            position: absolute;
            left: 47px;
            top: -9px;
            img {
              display: block;
              width: 100%;
              height: 50px;
            }
          }
        }
      }
      .footer_amic{
        width: 233px;
        height: 323px;
        box-sizing: border-box;
        padding: 48px 0 0 0;
        .footer_amic_s{
          width: 1px;
          height: 140px;
          background: #606265;
        }
      }
      .footer_amir{
        width: 789px;
        height: 323px;
        box-sizing: border-box;
        padding: 48px 84px 0 0;
        display: flex;
        justify-content: space-between;
        .footer_amir_v{
          width: 100%;
          height: auto;
          .footer_amir_vt{
            width: 100%;
            height: 60px;
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 20px;
            text-align: left;
            font-style: normal;
          }
          .footer_amir_vp{
            width: 100%;
            height: 38px;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            cursor: pointer;
          }
          .footer_amir_vp_n{
            width: 100%;
            height: auto;
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 12px;
            color: #B7B5BD;
            line-height: 17px;
            text-align: left;
            font-style: normal;
          }
        }
      }
    }
  }
</style>
